export default "__VITE_ASSET__e1PoP8Hd__"